export default __webpack_public_path__ + "static/media/Linkedin Learning Python.5e619572.webp";